"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxPersist = require("redux-persist");

// flow
var _default = _reduxPersist.persistStore;
exports.default = _default;